export * from './inmemory-offline-repository';
export * from './key-value-store-offline-repository';



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/datastore/repositories/offline-repositories/index.js